import { LoginAndRefreshTokenJsonResponse } from "../../common/model/login/jsonResponse";

export const loginAndRefreshTokenJsonResponse: LoginAndRefreshTokenJsonResponse = {
    status: 200,
    isSuccess: true,
    correlationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    message: "Login Success.",
    data: {
        accessToken: "string",
        expiresIn: 3600,
        tokenType: "string",
        refreshToken: "string"
    }
}